import React, {FC, MutableRefObject, ReactNode, useCallback, useMemo, useRef} from 'react';

export interface LegendsLimitWarningContextValue {
    toggleConfirmed: () => void;
    confirmed: MutableRefObject<boolean>;
}

export interface LegendsLimitWarningProviderProps {
    children: ReactNode;
}

export const LegendsLimitWarningContext = React.createContext<LegendsLimitWarningContextValue>({
    toggleConfirmed: () => {},
    confirmed: {current: false}
});

const LegendsLimitWarningProvider: FC<LegendsLimitWarningProviderProps> = ({
    children
}: LegendsLimitWarningProviderProps) => {
    const confirmed = useRef(false);

    const handleToggle = useCallback(() => {
        confirmed.current = !confirmed.current;
    }, []);

    const value = useMemo(
        () => ({
            confirmed,
            toggleConfirmed: handleToggle
        }),
        [handleToggle, confirmed]
    );

    return (
        <LegendsLimitWarningContext.Provider value={value}>
            {children}
        </LegendsLimitWarningContext.Provider>
    );
};

export default LegendsLimitWarningProvider;
